import { Form, Select } from 'antd';
import { useTranslation } from 'react-i18next';

import { TranslatedText } from '..';

import { Box } from '@/components/Utils';
import { RULES } from '@/constants';
import { useUniStudyBranchesOptions } from '@/hooks';

export const BranchSelect = () => {
  const form = Form.useFormInstance();
  const { getBranchOptions } = useUniStudyBranchesOptions();
  const options = getBranchOptions();
  const { t } = useTranslation('StudentOnboardingPageTranslations');

  return (
    <Box flexDirection="column" gap={12}>
      <TranslatedText i18nKey="BRANCH_GOAL" />
      <Form.Item name={['userInfo', 'studyBranch']} rules={[RULES.REQUIRED]}>
        <Select
          options={options}
          placeholder={t('SELECT_BRANCH')}
          onChange={() => {
            form.setFieldValue(['userInfo', 'degree'], undefined);
            form.setFieldValue(['userInfo', 'university'], undefined);
            form.setFieldValue(['userInfo', 'otherUniversity'], undefined);
            form.setFieldValue(['userInfo', 'otherDegree'], undefined);
          }}
        />
      </Form.Item>
    </Box>
  );
};
